import type { MapStateToProps } from 'react-redux';
import { connect } from 'react-redux';
import type { AppState } from 'state/state.model';
import {
  getBatchPayoffType,
  getBatchProductSubType,
  getBatchProductType,
  getBatchWrapper,
  isBatchProductValidated,
  isFetchingBatchTabContent,
} from 'state/workspaces/batch/tabContent/tabContent.selectors';

import type { BatchWorkspaceOwnProps, BatchWorkspaceStateProps } from './BatchWorkspace.models';

export const mapStateToProps: MapStateToProps<BatchWorkspaceStateProps, BatchWorkspaceOwnProps, AppState> = (
  state: AppState,
  props: BatchWorkspaceOwnProps,
) => {
  return {
    isLoading: false,
    productSubtype: getBatchProductSubType(state, props.tabId),
    productType: getBatchProductType(state, props.tabId),
    wrapper: getBatchWrapper(state, props.tabId),
    payoffType: getBatchPayoffType(state, props.tabId),
    isProductValidated: isBatchProductValidated(state, props.tabId),
    tabId: props.tabId,
    isFetchingBatchTabContent: isFetchingBatchTabContent(state, props.tabId),
  };
};

export const connectedBatchWorkspace = connect<BatchWorkspaceStateProps, {}, BatchWorkspaceOwnProps, AppState>(
  mapStateToProps,
);
